import { render, staticRenderFns } from "./ModalRemoveUser.vue?vue&type=template&id=6648f792&"
import script from "./ModalRemoveUser.vue?vue&type=script&lang=js&"
export * from "./ModalRemoveUser.vue?vue&type=script&lang=js&"
import style0 from "./ModalRemoveUser.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports